'use client'

import React, { useState, useEffect, useRef } from 'react'
import store from "@/redux/store";
import { v4 as uuid } from "uuid";

import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { SelectBox } from "@/components/holders/SelectBox";
import { Switch,Label, Field } from '@headlessui/react'
import { Calender } from '@/components/holders/Calender';
import { open, close, setPos } from '@/reducers/Window'

export default function AddInvoiceRowTimeRegistration({...props}) {
    const [fixedPrice, setFixedprice] = useState( props?.invoiceRow.fixedPrice )
    const [selectedVat, setSelectedVat] = useState(props.selectedVat);
    const [selectedRegistrationType, setSelectedRegistrationType] = useState( {id:0, name: ""} );
    const typeRegistrations = [{id:1, name: "Alle openstaande tijdregistraties"}, {id:2, name: "Eigen selectie"}]

    

    const filterNonNumeric =(evt, max) => {
        if(evt.which > 41 && evt.which != 190 ) {
            if ((evt.which < 48 || evt.which > 57) )
            {
                evt.preventDefault();
            }
            if(evt.target.attributes.getNamedItem("max")) {
                let maxValue = evt.target.attributes.getNamedItem("max").value;
                let newValue = evt.target.value+""+evt.key;
                if( parseFloat(newValue) > parseFloat(maxValue) ) {
                 evt.preventDefault();   
                }
            }
        }    
    }
    
    const onChangeFixedPrice=(event) => {
        let newVal = !fixedPrice;
        props.invoiceRow.setFixedPrice(newVal);
        setFixedprice(newVal);
    }
    
    useEffect(() => {
        return () => {
                props.updateInvoiceRowHandler(props.invoiceRow);
        };
      }, []);

      const onFocusOut= (event, name) => {
        let keyName = event.target.name;
        let val = event.target.value;
        props.invoiceRow.setValue(keyName,val);
        props.updateInvoiceRowHandler(props.invoiceRow);

      }
      
    const setValueCombobox= (name, selected) => {
        setSelectedRegistrationType(selected);
    }
    const onCLoseSelectTimeRegHandler = (invoiceRow) => {
        if(props?.updateInvoiceRowHandler) {
            
            invoiceRow.calculate();
            props.updateInvoiceRowHandler(invoiceRow);
        
        }
      }
    const timeeghandler = (event) => {
        event.preventDefault();
        
        store.dispatch( open({childWindow:'timeRegistration', title: 'Selectie tijdregistraties', onCloseHandler: onCLoseSelectTimeRegHandler, width:100, height:100, data: {customerKey: props.customer.key, invoiceRow: props?.invoiceRow}}) );        

        
        return false;
    }
    
    
  return (
<>


            <div className="space-y-8 border-b border-gray-900/10 ">
              <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  Omschrijving
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                
                                   <textarea
            id="description"
            name="description"
            rows={4}
            onBlur={(event) => onFocusOut(event, name)}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            defaultValue={props?.invoiceRow.description}
          />
                </div>
              </div>
             </div>

               <div className="space-y-8 border-b border-gray-900/10 ">
                 <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                   <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                     Vaste prijs afspraak
                   </label>
                   <div className="mt-2 sm:col-span-2 sm:mt-0">

                   <input key={uuid().slice(0, 8)} type="checkbox" defaultChecked={fixedPrice} onChange={(event) => onChangeFixedPrice(event)}/>                

                   
                   </div>
                 </div>
                </div>

                {fixedPrice && 
                          <div className="space-y-8 border-b border-gray-900/10 ">
                            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                          
                      <label htmlFor="phone-number" className="block text-sm font-medium leading-6 text-gray-900">
                        Prijs
                      </label>
                      <div className="relative mt-2 rounded-md shadow-sm">

                        <input
                          id="price"
                          name="price"
                          onBlur={(event) => onFocusOut(event, name)}
                          type="text"
                          max="1000000"
                          filtertype="price"
                          onKeyDown={(event,max) => filterNonNumeric(event, max)}
                          placeholder=""
                          defaultValue={ props?.invoiceRow.price }
                          className="block w-full rounded-md border-0 py-1.5 pl-16 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>

                </div>          
                          </div>
                }
                
                <div className="space-y-8 border-b border-gray-900/10 ">
                  <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                    <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                      Selectie tijd registratie
                    </label>
                    <div className="mt-2 sm:col-span-2 sm:mt-0">

                    <button
                        type="button"
                      onClick={() => timeeghandler(event)}
                      className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    >
                      Tijd registraties selecteren
                    </button>

                    
                    </div>
                  </div>
                 </div>

                 
             
</>

  )
}
